/* eslint-disable @typescript-eslint/naming-convention */
/* eslint-disable @typescript-eslint/member-ordering */
import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { config } from '../confing';
import { OauthService } from './oauth.service';


@Injectable({
  providedIn: 'root'
})
export class CatalogoService {

  constructor(
    private httpClient: HttpClient,
    private oauth: OauthService
  ) {}


  public  addictionalInfo(codice: string) {
      const token = this.oauth.getToken();
      const header = new HttpHeaders({
      Accept: 'application/json',
      'Content-Type': 'application/json',
      Authorization: 'Bearer ' + token
    });
    const options = {
      headers: header
    };
    return  this.httpClient.get(`${config[config.env].base_url}/catalogo/${codice}`, options);
  }

}
